var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.id && !_vm.model.buyer)?_c('btn-loader',{attrs:{"variant":"outline-primary","loader":_vm.loading,"text":"Crear usuario para la tienda"},on:{"clicked":_vm.createBuyer}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }